import React, { useEffect, useState } from "react";
import { getData, postData } from "../services/api.service";
import BackButton from "../components/common/BackButton";
import OrderDetail from "../components/OrderDetail";
import {
  FaCheck,
  FaInfoCircle,
  FaClock,
  FaTimes,
  FaReceipt,
} from "react-icons/fa";
import ModalWindow from "../components/ModalWindow";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import RefreshButton from "../components/common/RefreshButton";
import { swalAlertSuccess } from "../components/common/Alerts";
import "../styles/Orders.css";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Estado para el modal de cancelar pedido
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [orderToCancel, setOrderToCancel] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await getData("/api/get_orders_user");
        if (res.status === 200) {
          setOrders(res.data.orders);
        } else {
          setOrders([]);
        }
      } catch (error) {
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const handleShowDetails = (order) => {
    setSelectedOrder(order);
    setModalOpen(true);
  };

  const handleCancelOrder = async (orderId) => {
    const new_status = 5;
    const data = {
      order_id: orderId,
      status: new_status,
    };
    try {
      postData("/api/order/change_status", data).then((res) => {
        if (res.status === 200) {
          swalAlertSuccess(
            "Pedido cancelado",
            "El pedido ha sido cancelado exitosamente.",
            () => {
              window.location.reload();
            }
          );
        }
      });
    } catch (error) {
      alert("No se pudo cancelar el pedido. Intenta nuevamente.");
    }
    setCancelModalOpen(false);
  };

  console.log("Selected Order:", selectedOrder);

  return (
    <>
      <div className="container-fluid p-3 bg-orange position-relative text-white">
        <div className="row align-items-center">
          <div className="col-4">
            <BackButton />
          </div>
          <div className="col-4 text-center">
            <h2 className="mb-0">
              <FaReceipt className="me-2" />
              Mis Pedidos
            </h2>
          </div>
          <div className="col-4 text-end">
            <RefreshButton onClick={() => window.location.reload()} />
          </div>
        </div>
      </div>
      
      <div className="container mt-4">
        {loading ? (
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p className="loading-text">Cargando tus pedidos...</p>
          </div>
        ) : orders.length === 0 ? (
          <div className="empty-state">
            <FaReceipt className="empty-state-icon" />
            <h3 className="empty-state-title">No tienes pedidos</h3>
            <p className="empty-state-text">
              Cuando realices tu primer pedido, aparecerá aquí.
            </p>
          </div>
        ) : (
          <ul className="orders-list">
            {orders.map((order) => {
              let statusClass = "";
              let statusText = "";
              let StatusIcon = null;

              if (order.status === 1) {
                statusClass = "status-sent";
                statusText = "Pedido enviado";
                StatusIcon = <FaInfoCircle />;
              } else if (order.status === 2) {
                statusClass = "status-preparing";
                statusText = "En preparación";
                StatusIcon = <FaClock />;
              } else if (order.status === 3) {
                statusClass = "status-ready";
                statusText = "Pedido listo";
                StatusIcon = <FaCheck />;
              } else if (order.status === 5) {
                statusClass = "status-cancelled";
                statusText = "Pedido cancelado";
                StatusIcon = <FaTimes />;
              }

              return (
                <li key={order.id} className="order-card">
                  <div className="order-card-header">
                    <h3 className="order-id">Pedido #{order.show_order_id || order.id}</h3>
                    <div className={`status-indicator ${statusClass}`}>
                      {StatusIcon}
                      {statusText}
                    </div>
                  </div>
                  
                  <div className="order-summary">
                    <p><strong>Total:</strong> ${order.total_price}</p>
                    <p><strong>Sucursal:</strong> {order.branch_name}</p>
                    <p><strong>Hora:</strong> {order.end_time}</p>
                  </div>

                  <div className="order-actions">
                    <button
                      className="btn-modern btn-primary-modern"
                      onClick={() => handleShowDetails(order)}
                    >
                      <FaReceipt />
                      Ver detalle
                    </button>
                    {order.status === 1 && (
                      <button
                        className="btn-modern btn-danger-modern"
                        onClick={() => {
                          setOrderToCancel(order);
                          setCancelModalOpen(true);
                        }}
                      >
                        <FaTimes />
                        Cancelar
                      </button>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
      {selectedOrder && (
        <ModalWindow
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title=""
          body={<OrderDetail order={selectedOrder} />}
          size="lg"
        />
      )}
      {/* Modal para confirmar cancelación */}
      {orderToCancel && (
        <ModalWindow
          modalOpen={cancelModalOpen}
          setModalOpen={setCancelModalOpen}
          title="Cancelar pedido"
          body={
            <div>
              <p>
                ¿Estás seguro que deseas cancelar el pedido #{orderToCancel.id}?
                Esta acción no se puede deshacer.
              </p>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  className="btn btn-success"
                  onClick={() => setCancelModalOpen(false)}
                >
                  No, volver
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleCancelOrder(orderToCancel.id)}
                >
                  Sí, cancelar pedido
                </button>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default Orders;
